if (!process.env.GOOGLE_MAPS_API_KEY) {
  throw new Error('No GOOGLE_MAPS_API_KEY provided');
}
if (!process.env.GOOGLE_MAP_ID) {
  throw new Error('No GOOGLE_MAP_ID provided');
}

export const GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY as string;
export const GOOGLE_MAP_ID = process.env.GOOGLE_MAP_ID as string;

export const mapOptions = {
  center: {lat: 51.1642292, lng: 10.4541194},
  zoom: 6,
  disableDefaultUI: true,
  zoomControl: true,
  mapId: GOOGLE_MAP_ID
};
